import { FinderLocation } from "@/types/FinderLocation";

const fetchLocations = async (params: URLSearchParams) => {
  try {
    const response = await fetch(`/api/product-locations?${params.toString()}`);
    if (response.status >= 400) {
      throw new Error("Failed to fetch locations.");
    }
    const { locations }: { locations: FinderLocation[] } = await response.json();

    return locations;
  } catch (error) {
    return [];
  }
};

export default fetchLocations;
